export default __webpack_public_path__ + "static/media/tribal-Museum.e07b26d4.jpg";